const PERFORMANCE_CATEGORY = '2,';
const TARGETING_CATEGORY = '4,';
const MAX_ATTEMPTS = 100;
const POLL_INTERVAL = 100;

/**
 * @param {'granted' | 'denied'} status
 */
function recordConsentInKlaviyo(status) {
  if (typeof klaviyo !== 'undefined' && klaviyo.isIdentified()) {
    klaviyo.identify({ ad_personalization: status, ad_user_data: status });
  }
}

/**
 * @param {boolean} trackingConsent
 */
function sendConsent(trackingConsent) {
  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    /** @param {Error | undefined} error */
    (error) => {
      if (error) throw error;
      window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, () => {});
    }
  );
}

function handleConsent() {
  const groups = window.OnetrustActiveGroups;
  const trackingConsent = groups.includes(PERFORMANCE_CATEGORY);
  const targetingConsent = groups.includes(TARGETING_CATEGORY);

  recordConsentInKlaviyo(targetingConsent ? 'granted' : 'denied');
  sendConsent(trackingConsent);
}

/**
 * @param {number} attempts
 */
function pollForOneTrust(attempts) {
  if (typeof window.OnetrustActiveGroups === 'string') {
    handleConsent();
    window.OptanonWrapper = handleConsent;
    return;
  }

  if (attempts < MAX_ATTEMPTS) {
    setTimeout(() => pollForOneTrust(attempts + 1), POLL_INTERVAL);
  }
}

pollForOneTrust(0);
